var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup1359(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-525 -199)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(525 199)",
    fill: "#fff",
    stroke: "#00e2a2",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M534.467,217.234l6.2,4.766,11.2-12.966",
    transform: "translate(0.333 2.166)",
    fill: "none",
    stroke: "#00e2a2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1359);
export default __webpack_public_path__ + "static/media/Group 1359.b0b443f8a5f68a6a1f9db0e4a977627b.svg";
export { ForwardRef as ReactComponent };